<h2 mat-dialog-title>{{ 'label.user.search.references.title' | translate }}</h2>
<mat-dialog-content>
  <div class="neq-simple-references-search-popin" fxLayout="column">
    <div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">
      <div class="neq-container">
        <div fxLayout="column" fxLayoutGap="1rem">
          <div fxLayout="row" fxLayoutAlign="strech">
            <div class="mat-form-field" fxFlex="95" fxLayout="column" fxLayoutAlign="center none">
              <div fxLayout="row"><span>{{ 'label.common.reference' | translate }} *</span></div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <neq-select-autocomplete (change)="onChange($event)" [dataSource]="search"
                                         formControlName="reference" fxFlex>
                </neq-select-autocomplete>

                <neq-icon svgIcon="recherche"></neq-icon>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start stretch">
            <div *ngIf="selected" fxFlex="95">
              <mat-form-field fxFlex="100">
                <input [placeholder]="'label.common.reference.description' | translate" disabled
                       matInput value="{{selected?.description}}">
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="selected" fxLayout="row" fxLayoutAlign="start stretch">
            <div fxFlex="50">
              <mat-form-field fxFlex="95">
                <input [placeholder]="'label.common.reference.prediction-model' | translate" disabled
                       matInput value="{{selected?.predictionModelLabel}}">
              </mat-form-field>
            </div>
            <div fxFlex="50" *ngIf="selected.predictionModelDescription">
              <mat-form-field fxFlex="95">
                <input [placeholder]="'label.common.prediction-model.description' | translate" disabled
                       matInput value="{{selected?.predictionModelDescription}}">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="asi-container" fxLayout="row" fxLayoutAlign="end center">
    <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.cancel' | translate }}"
            (click)="onCancel()"></button>
    <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.confirm' | translate }}"
            [disabled]="isSubmitDisabled" (click)="onFormSubmit()"></button>
  </div>
</mat-dialog-actions>
